import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";
import { CashFlowReportRowPath } from "@common/dto/reports/cash-flow-tab-report-response.dto";
import { MoneyDirection } from "@common/constants";

interface CashFlowDrillDownModalParams {
    category?: string[];
    counterpartyId?: string[];
    withEmptyOrUnverifiedCounterparty?: boolean;
    hasCounterparty?: boolean;
    path: CashFlowReportRowPath[];
    columnId: string;
    direction?: MoneyDirection;
}

export interface CashFlowDrillDownContextValue {
    params?: CashFlowDrillDownModalParams;
    open: (params: CashFlowDrillDownModalParams) => void;
    close: () => void;
}

export const CashFlowDrillDownContext =
    createContext<CashFlowDrillDownContextValue>({
        open: noop,
        close: noop,
    });

export function useCashFlowDrillDownContext(): CashFlowDrillDownContextValue {
    const ctx = useContext(CashFlowDrillDownContext);
    if (!ctx) {
        throw new Error(
            "Can only be used inside a TransactionsDrillDownContextProvider",
        );
    }

    return ctx;
}
